"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEX_REPLACE = void 0;
const tab_1 = require("../../../tab");
exports.REGEX_REPLACE = {
    description: 'Uses regex on {regex_pattern} to search on {original_string} and replace with {replace}',
    arg_names: ['original_string', 'regex', 'replace'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['string'],
            required: true,
            replaceNormalizer: {
                replace: `\\`,
                replace_with: '\\\\',
            },
        },
        {
            types: ['string'],
            required: true,
        },
    ],
    args_description: [
        'string to be searched and replaced',
        'regex pattern to search',
        'replace string',
    ],
    return_type: tab_1.ColumnType.STRING,
};
